import { render, staticRenderFns } from "./ClientAccountSummaryRepair.vue?vue&type=template&id=58359898&scoped=true"
import script from "./ClientAccountSummaryRepair.vue?vue&type=script&lang=js"
export * from "./ClientAccountSummaryRepair.vue?vue&type=script&lang=js"
import style0 from "./ClientAccountSummaryRepair.vue?vue&type=style&index=0&id=58359898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58359898",
  null
  
)

export default component.exports